import styled from 'styled-components';

export const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  font-style: normal;
  font-size: 11px;
  line-height: 18px;
`;

export const Header = styled.div`
  font-weight: 500;
  color: #31394d;
`;

export const SubHeader = styled.div`
  font-weight: 400;
  color: #748aa1;
`;
